import { FC } from 'react';

type Props = {
	className?: string;
};

const Analytics_01_Icon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M5.78906 14.2107V10.8423'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
			/>
			<path
				d='M10 14.2105V5.78955'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
			/>
			<path
				d='M14.2109 14.2103V9.15771'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
			/>
			<path
				d='M2 9.99992C2 6.22872 2 4.34313 3.17156 3.17156C4.34313 2 6.22872 2 9.99992 2C13.7711 2 15.6567 2 16.8283 3.17156C17.9998 4.34313 17.9998 6.22872 17.9998 9.99992C17.9998 13.7711 17.9998 15.6567 16.8283 16.8283C15.6567 17.9998 13.7711 17.9998 9.99992 17.9998C6.22872 17.9998 4.34313 17.9998 3.17156 16.8283C2 15.6567 2 13.7711 2 9.99992Z'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default Analytics_01_Icon;
